// CardsPage – Styled and Filterable View of Video Decks
import React, { useEffect, useState, useRef } from "react";
import { ref, listAll, getDownloadURL } from "firebase/storage";
import { storage } from "./firebase";
import "./UncannyValleyGame.css";
import { db } from "./firebase";
import { getDocs, collection } from "firebase/firestore";


const formatLabel = (label) => label.replace(/\./g, ' ');

const parseVideoName = (filename) => {
  const [sub1, role, setting, sub2, color, format] = filename.replace(".mp4", "").split("_");
  return { sub1, role, setting, sub2, color, format };
};
const getUncannyScores = () => {
  const data = localStorage.getItem("uncannyScores");
  return data ? JSON.parse(data) : {};
};

const fetchScores = async () => {
  const snap = await getDocs(collection(db, "uncannyScores"));
  const scores = {};
  snap.forEach(doc => {
    scores[doc.id] = doc.data().score;
  });
  return scores;
};

const fetchDeckVideos = async () => {
  const folders = ["videos_A", "videos_B"];
  const allDecks = {};
  for (const folder of folders) {
    const folderRef = ref(storage, folder);
    const result = await listAll(folderRef);
    const files = result.items.filter((item) => item.name.endsWith(".mp4"));
    const list = await Promise.all(
      files.map(async (item) => {
        const url = await getDownloadURL(item);
        const attributes = parseVideoName(item.name);
        return { filename: item.name, url, ...attributes };
      })
    );
    allDecks[folder] = list;
  }
  const scores = await fetchScores();

  for (const deck in allDecks) {
    allDecks[deck] = allDecks[deck].map((video) => ({
      ...video,
      uncannyScore: scores[video.filename] || 0,
    }));
  }

  return allDecks;

  };

export default function CardsPage() {
  const [videos, setVideos] = useState({ videos_A: [], videos_B: [] });
  const [filter, setFilter] = useState("");
  const videoRefs = useRef([]);
  const [isPaused, setIsPaused] = useState(true);
  const [sortByUncanny, setSortByUncanny] = useState(false);

  useEffect(() => {
    fetchDeckVideos().then(setVideos);
  }, []);

  const handleTagClick = (tag) => {
    setFilter(tag);
  };

  const togglePlayback = () => {
    const newState = !isPaused;
    videoRefs.current.forEach((vid) => {
      if (vid) newState ? vid.pause() : vid.play();
    });
    setIsPaused(newState);
  };

  const renderTags = (video) => {
    const tags = [video.sub1, video.sub2, video.role, video.setting, video.color, video.format];
    return (
      <div style={{ marginTop: "0.5rem", display: "flex", flexWrap: "wrap", gap: "0.3rem" }}>
        {tags.map((tag, i) => (
          <span
          key={i}
          onClick={() => handleTagClick(tag)}
          style={{
            background: "#d1eaff",
            borderRadius: "12px",
            padding: "0.2rem 0.6rem",
            fontSize: "0.8rem",
            cursor: "pointer",
            transition: "background 0.2s"
          }}
          title={tag}
        >
          {formatLabel(tag)}
        </span>
        
        ))}
      </div>
    );
  };

  

  const renderDeck = (deckName, list) => {
    const normalizedFilter = filter.toLowerCase().replace(/\s+/g, ".");
    let filtered = list.filter((v) =>
      !filter || Object.values(v).some((val) => val?.toLowerCase().includes(normalizedFilter))
    );
    
    if (sortByUncanny) {
      filtered = [...filtered].sort((a, b) => b.uncannyScore - a.uncannyScore);
    }
    


    return (
      <div>
        {!sortByUncanny && deckName !== "all" && (
          <h2 style={{ textAlign: "center", margin: "2rem 0 1rem" }}>
            {deckName === "videos_A" ? "Deck One" : "Deck Two"}
          </h2>
        )}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: "1.5rem" }}>
          {filtered.map((video, idx) => (
            <div key={idx} style={{ border: "1px solid #ccc", borderRadius: "8px", padding: "0.75rem", background: "#fdfdfd" }}>
              <video
                ref={(el) => videoRefs.current.push(el)}
                src={video.url}
                width="100%"
                controls
                muted
                loop
                style={{ borderRadius: "6px", marginBottom: "0.5rem" }}
              />
              {renderTags(video)}
              {sortByUncanny && (
                <p style={{ fontSize: "0.9rem", marginTop: "0.5rem" }}>
                  <strong>Uncanny Factor:</strong> {video.uncannyScore}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="cards-page" style={{ padding: "2rem", fontFamily: "Arial, sans-serif", background: "#f8f9fa" }}>
      <h1 style={{ textAlign: "center", marginBottom: "1rem" }}>Video Cards</h1>
      <div style={{ maxWidth: "600px", margin: "0 auto 1rem auto" }}>
        <input
          type="text"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          placeholder="Filter by any attribute..."
          style={{ width: "100%", padding: "0.6rem", fontSize: "1rem", border: "1px solid #ccc", borderRadius: "6px" }}
        />
        {filter && (
        <div style={{ textAlign: "center", marginTop: "0.5rem" }}>
            <button onClick={() => setFilter("")} style={{ padding: "0.3rem 0.7rem", fontSize: "0.9rem", borderRadius: "5px" }}>
              Clear Filter
            </button>
          </div>
        )}
      </div>
      <div style={{ textAlign: "center", marginBottom: "2rem" }}>
        <button onClick={togglePlayback} style={{ padding: "0.5rem 1rem", fontSize: "1rem", borderRadius: "6px" }}>
          {isPaused ? "Play All" : "Pause All"}
        </button>
        <button
          onClick={() => setSortByUncanny(!sortByUncanny)}
          style={{ padding: "0.5rem 1rem", fontSize: "1rem", borderRadius: "6px", marginLeft: "1rem" }}
        >
          {sortByUncanny ? "Sort by Deck" : "Sort by Uncanny Score"}
        </button>

      </div>
      {sortByUncanny ? (
        renderDeck("all", [...videos.videos_A, ...videos.videos_B])
      ) : (
        <>
          {renderDeck("videos_A", videos.videos_A)}
          <hr style={{ margin: "3rem 0" }} />
          {renderDeck("videos_B", videos.videos_B)}
        </>
      )}
    </div>
  );
}
